/** Frame rectangles of a row-major sprite sheet of square cells; `sheetWidth` decides the column count. */
export function sheetFrameRects(cell: number, frames: number, sheetWidth: number): Array<{ x: number; y: number; w: number; h: number }> {
  const cols = Math.max(1, Math.floor(sheetWidth / cell));
  const out: Array<{ x: number; y: number; w: number; h: number }> = [];
  for (let i = 0; i < frames; i++) out.push({ x: (i % cols) * cell, y: Math.floor(i / cols) * cell, w: cell, h: cell });
  return out;
}
